import React, { Component } from 'react';
import withAuthorization from '../Session/withAuthorization';
import { db } from '../../firebase';
import ReactTable from "react-table";
import { Input, Label, FormGroup, Form, Col, Row } from 'reactstrap';
import * as states from '../../constants/states';
import * as common from '../../constants/common';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import { functions } from '../../firebase/firebase';
import Spinner from '../Spinner';
import { toast } from 'react-toastify';
import './index.css'

class AdminPage extends Component {

  constructor(props) {
      super(props);
  
      this.state = {
        complaints: [],
        showClosedComplains:true,
        isLoading:true
      };

      this.renderEditable = this.renderEditable.bind(this);
      this.renderState = this.renderState.bind(this);
    }

    onChange(showClosedComplains){
        db.updateUsershowClosedComplainsSetting(this.props.sessionStore.authUser.uid, !this.state.showClosedComplains)
        .then(()=>
          this.setState({showClosedComplains:!this.state.showClosedComplains})
        )
        .catch(error => {
            toast.error(common.ERROR_MESSAGE, {
                toastId:"Error message",
                position: toast.POSITION.BOTTOM_RIGHT                  
              });
        });
    }

    makePlaceholderFilter(filter, onChange,placeholder){
        return( <input type='text'
                 placeholder={placeholder}
                 value={filter ? filter.value : ''}
                 onChange={event => onChange(event.target.value)}
          />)
        
    }

    renderEditable(cellInfo) {
      var inputClassName = 'editableInput';
      const complaints = [...this.state.complaints];

      if(!!complaints[cellInfo.index][cellInfo.column.id]){
        inputClassName = '';
      }

      return (
        <div
          className={inputClassName}
          contentEditable
          suppressContentEditableWarning
          onBlur={e => {
            complaints[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
            db.updateComplainComment(complaints[cellInfo.index].key,
                complaints[cellInfo.index][cellInfo.column.id])
            .then(()=>{
                toast.success("Atnaujinta",{
                    position: toast.POSITION.BOTTOM_RIGHT
                  });
                this.setState({ complaints });
            })
            .catch(error => {
                toast.error(common.ERROR_MESSAGE, {
                    toastId:"Error message",
                    position: toast.POSITION.BOTTOM_RIGHT                  
                  });
            });
            
          }}
          dangerouslySetInnerHTML={{
            __html: this.state.complaints[cellInfo.index][cellInfo.column.id]
          }}
        />
      );
    }

    renderState(cellInfo){
        const complaints = [...this.state.complaints];

        return(
            <Input 
            type="select"
            name="select"
            onChange={event =>{
                complaints[cellInfo.index][cellInfo.column.id] = event.target.value;
                db.updateComplainState(complaints[cellInfo.index].key, event.target.value)
                .then(()=>{
                    toast.success("Atnaujinta",{
                        position: toast.POSITION.BOTTOM_RIGHT
                      });
                    this.setState({ complaints });  
                })
                .catch(error => {
                    toast.error(common.ERROR_MESSAGE, {
                        toastId:"Error message",
                        position: toast.POSITION.BOTTOM_RIGHT                  
                      });
                });
            }}
            value={complaints[cellInfo.index].state}>

            {Object.keys(states).map(key =>{
                return <option key={key}>{states[key]}</option>
              })}
    
          </Input>
        )
    }

    filterMethod( filter, row ){
        const   rowText = row[filter.id].toLowerCase();
        const   searchText = filter.value.toLowerCase();
        return  rowText.indexOf(searchText) !== -1;
    }
  
    componentDidMount() {

      var getComplains = functions.httpsCallable('getComplainsData');

      getComplains({userId:this.props.sessionStore.authUser.uid})
      .then(snapshotComplains => {
            if(!this.props.sessionStore.authUser){
                return;
            }
            db.onceGetUser(this.props.sessionStore.authUser.uid)
            .then(snapshotUser =>{
                let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour:'numeric', minute:'numeric' };
                let complaints = snapshotComplains.data;
                let user = snapshotUser.val();

                if(complaints){
                    Object.keys(complaints).map(key =>{
                        complaints[key].createDate = new Date(complaints[key].dateCreated).toLocaleDateString("lt-LT",options);
                        complaints[key].endDate = new Date(complaints[key].dateEdited).toLocaleDateString("lt-LT",options);
                    });
                    return this.setState(() => ({ 
                        complaints: complaints,
                        showClosedComplains: user.showClosedComplains,
                        isLoading:false 
                    })) 
            }})
      })
      .catch(error => {
            toast.error(common.ERROR_MESSAGE, {
                toastId:"Error message",
                position: toast.POSITION.BOTTOM_RIGHT                  
            });

            return this.setState(() => ({ 
                complaints: [],
                showClosedComplains: true,
                isLoading:false
            }));
       });
    }
  
  render() {

  let complaints = this.state.complaints.map(a => ({...a}));
  let { showClosedComplains, isLoading } = this.state;
  const filterText = 'Ieškoti';

  Object.keys(complaints).map(key=>{
      if(!showClosedComplains && complaints[key].state === states.ComplainClosed){
          delete complaints[key]
      }
  })

  //refactor do something with table width
  const columns = [
    {
        Header: "Vartotojas",
        id: "alias",
        accessor: row => row.alias + ' ' + (row.telephone ? row.telephone: ''),
        Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
        filterMethod: (filter, row) => this.filterMethod(filter, row),
        style: { 
            'whiteSpace': 'unset',
            'wordWrap': 'break-word' 
        },
    },
    {
        Header: 'Tema',
        accessor: 'subject',
        Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
        filterMethod: (filter, row) => this.filterMethod(filter, row)
    },
    {
        Header: 'Aprašymas',
        accessor: 'complainText',
        style: { 
          'whiteSpace': 'unset',
          'wordWrap': 'break-word' 
        },
        Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
        filterMethod: (filter, row) => this.filterMethod(filter, row)   
    },  
    {
        Header: 'Sukūrimo data',
        accessor: 'createDate',
        width: 150,
        Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText)
    },
    {
      Header: 'Keitimo data',
      accessor: 'endDate',
      width: 150,
      Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText)
    },
    {
        Header: 'Būsena',
        accessor: 'state',
        Cell: this.renderState,
        width: 170,
        Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
        filterMethod: (filter, row) => this.filterMethod(filter, row)
    },
    {
      Header: 'Komentaras',
      accessor: 'comment',
      style: { 
          'whiteSpace': 'unset',
          'wordWrap': 'break-word'
         },
      Cell: this.renderEditable,
      Filter:({filter, onChange}) => this.makePlaceholderFilter(filter,onChange,filterText),
      filterMethod: (filter, row) => this.filterMethod(filter, row)
    }
  ]

  if(isLoading){
    return(<Spinner></Spinner>)
  }
  else if(complaints === undefined || complaints.length === 0){
      return <p className = "text-center">Nėra incidentų</p>
  }
  else{
    return (
        <div>
            <Row>
                <Col className="checkbox-showClosedComplains">
                  <Form>
                      <FormGroup check>
                          <Label check>
                              <Input type="checkbox" checked={showClosedComplains} onChange={() =>   
                                  this.onChange(!this.state.showClosedComplains)
                              } />{' '}
                              Rodyti išspręstus incidentus
                          </Label>
                      </FormGroup>
                  </Form>
          </Col>
          </Row>
          <Row>
              <Col>
                  <ReactTable
                      data={complaints}
                      columns={columns}
                      minRows={0}
                      filterable={true}
                      defaultSorted={[
                        {
                            id: "createDate",
                            desc: true
                        }
                        ]}
                    defaultPageSize={10}
                    nextText={"Kitas"}
                    previousText={"Ankstesnis"} 
                    pageText={"Puslapis"}
                    ofText={"iš"}
                    rowsText={"eilutės"} 
                  />
              </Col>
          </Row>
      </div>
    );
  }}
}

const authCondition = (authUser, token) => {
      return !!authUser && token.claims.isAdmin;
  };

export default compose(
  withAuthorization(authCondition),
  inject('sessionStore'),
  observer
)(AdminPage);


// WEBPACK FOOTER //
// ./src/components/Admin/index.js